import {DiscoverBannerSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {
  originClick,
  TrackingPromotionCreative,
} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions, useTrackOriginClick} from '@aboutyou/tracking';
import {
  Button,
  FONT_SIZES,
  FONT_WEIGHTS,
  Image,
  UnstyledLinkLinaria,
  useGetAriaLabelFromUrl,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const DiscoverBanner: React.FC<
  DiscoverBannerSection & {className?: string}
> = ({className, cover, cta, promotionTracker}) => {
  const trackOriginClick = useTrackOriginClick();
  const getAriaLabelFromUrl = useGetAriaLabelFromUrl();

  return (
    <TrackPromotions
      promotion={{
        source: TrackingPromotionCreative.BasFlyoutTeaser,
        advertisement: {
          id: promotionTracker?.promotionId ?? '',
          name: promotionTracker.promotionName ?? '',
          path: promotionTracker.destination ?? '',
          promotionId: promotionTracker.promotionId ?? '',
          creativeName: promotionTracker.creativeName ?? '',
          locationId: promotionTracker.locationId,
        },
      }}
      streamPosition={0}
      triggerOnce
    >
      <Wrapper className={className}>
        <UnstyledLinkLinaria
          to={cta.linkTarget.url}
          aria-label={getAriaLabelFromUrl(cta.linkTarget.url)}
        >
          <Image
            src={cover.url}
            ratio={
              cover.aspectRatio
                ? `${cover.aspectRatio.width}:${cover.aspectRatio.height}`
                : '3.3:1'
            }
            breakpoints={[{columns: 1}]}
          />
        </UnstyledLinkLinaria>
        <CTA
          href={cta.linkTarget.url}
          onClick={trackOriginClick(promotionTracker.locationId as originClick)}
          size="fit-width"
        >
          {cta.label}
        </CTA>
      </Wrapper>
    </TrackPromotions>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  > img {
    width: 100%;
    object-fit: cover;
  }
`;

const CTA = styled(Button)`
  && {
    position: absolute;
    right: 16px;
    font-size: ${FONT_SIZES.px12};
    font-weight: ${FONT_WEIGHTS.mediumHeavy};
  }
`;
